const predicationChartObject = {
    zoomEnabled: true,
    title: {
        text: "",
    },
    axisX: {
        title: "",
        valueFormatString: "YYYY-MM-DD HH:mm:ss",
        labelFontFamily: "Roboto-Regular",
        labelFontColor: "#444",
        labelFontSize: 12,
        margin: 10,
        tickLength: 15,
        labelAngle: 0,
        tickColor: "transparent",
       
    },
    axisY: {
        
        maximum: "",
        minimum: 0,
        prefix: "",
        includeZero: false,
        gridThickness: 0,
        gridColor: "#e8e8e8",
        labelFontFamily: "Roboto-Regular",
        labelFontColor: "#444",
        labelFontSize: 12,
        lineThickness: 0,
        tickLength: 10,
        tickColor: "transparent",
        stripLines:[]
    },
    toolTip: {
        shared: true,
        contentFormatter: function (e) {
            let content;
            let a;
            if (e.chart.options.myValue) {
                content =
                    e.entries[0].dataPoint.x.toLocaleString() +
                    "<br/><strong>Actual Trend</strong>  <br/>";
                a = {
                    dataSeries: { name: "" },
                    dataPoint: { y: "na" },
                };
            }
            else {
                if (e.chart.options.type === "acoustics") {
                    if (e.entries.length <= 1) {
                        content =
                            e.entries[0].dataPoint.x.toLocaleString() +
                            "<br/><strong>Predicted Trend</strong> <br/>";
                        a = {
                            dataSeries: { name: "" },
                            dataPoint: { y: "na" },
                        };
                    } else {
                        content =
                            e.entries[0].dataPoint.x.toLocaleString() +
                            "<br/> <strong>Actual Trend</strong>  <br/>";
                        a = {
                            dataSeries: {
                                name: "<strong>Predicted Trend</strong>",
                            },
                            dataPoint: { y: "na" },
                        };
                    }
                } else {
                    if (e.entries.length <= 3) {
                        content =
                            e.entries[0].dataPoint.x.toLocaleString() +
                            "<br/><strong>Predicted Trend</strong> <br/>";
                        a = {
                            dataSeries: { name: "" },
                            dataPoint: { y: "na" },
                        };
                    } else {
                        content =
                            e.entries[0].dataPoint.x.toLocaleString() +
                            "<br/> <strong>Actual Trend</strong>  <br/>";
                        a = {
                            dataSeries: {
                                name: "<strong>Predicted Trend</strong>",
                            },
                            dataPoint: { y: "na" },
                        };
                    }
                }
            }
            if (e.chart.options.type === "acoustics") {
                e.entries.splice(1, 0, a);
            } else {
                e.entries.splice(3, 0, a);
            }
            for (var i = 0; i < e.entries.length; i++) {
                content +=
                    e.entries[i].dataPoint.y === "na"
                        ? e.entries[i].dataSeries.name
                        : e.entries[i].dataSeries.name +
                        " " +
                        "<strong>" +
                        e.entries[i].dataPoint.y.toFixed(2) +
                        " " +
                        e.chart.options.unit +
                        "</strong>";
                content += "<br/>";
            }
            return content;
        },
    },
    legend: {
        verticalAlign: "top",
        horizontalAlign: "center",
        fontSize: 19,
        fontColor: "#191919",
        fontWeight: "normal",
        markerMargin: 10,
        fontFamily: "Roboto-Regular",
        cursor: "pointer",
        itemclick: function (e) {
            if (
                typeof e.dataSeries.visible === "undefined" ||
                e.dataSeries.visible
            ) {
                e.dataSeries.visible = false;
            } else {
                e.dataSeries.visible = true;
            }
            e.chart.render();
        },
    },
    data: []
};

module.exports = predicationChartObject;